import { Component, OnInit,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {MatSnackBar} from '@angular/material';
import { Http, Response,Headers } from '@angular/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { NgForm } from '@angular/forms';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA,MatDialogRef} from '@angular/material';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-enquiryreply',
  templateUrl: './enquiryreply.component.html',
  styleUrls: ['./enquiryreply.component.css']
})
export class EnquiryreplyComponent implements OnInit {

  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  dtOptions: DataTables.Settings = {};
  dtElement: DataTableDirective;
  doubts:any=[];
  dtTrigger: Subject<any> = new Subject();
  user_permissions:any=[];
  enquirys:any=[];
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private cookie:CookieService) { }

  ngOnInit() {
    //let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      ordering: false
    };

     this.http.get(this.helper.base_url+'http/get/enquiryreply',{ headers: this.headers })
      
      .subscribe(data => {
        this.enquirys = JSON.parse(data['_body']);
        
          this.dtTrigger.next();
        
       
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/enquiryreply/enquiryreply.component.ts